import React from 'react';
import { extractNameAndCode } from '@/lib/extractItemCode';

export default function StokSampleLabelSticker({
  vendorName = '',
  itemName = '',
  code = '',
  tanggal = '',
  labelTag = 'Sample',
  scale = 1
}) {
  const goldenColor = '#000000';

  const toTitleCase = (str) => {
    if (!str) return '';
    return String(str)
      .toLowerCase()
      .replace(/\b\w/g, s => s.toUpperCase());
  };

  const extracted = extractNameAndCode(itemName, code);
  const cleanVendor = toTitleCase(vendorName || 'Vendor');
  const cleanItem = extracted.name || 'Nama Item';
  const cleanCode = extracted.code ? String(extracted.code).trim() : '';
  const cleanTanggal = tanggal || '';

  const hasCode = Boolean(cleanCode);
  const itemLen = cleanItem.length;

  // Dynamic Font Scaling & Adaptive Line Count:
  // - Jika ADA kode: font mengecil bertahap (5.5pt -> 4.8pt -> 4.2pt) agar 2 baris nama + 1 baris kode pas rapi
  // - Jika KODE KOSONG: area bawah kosong dimanfaatkan hingga 3 baris teks
  let itemFontSize = '5.5pt';
  let itemLineHeight = 1.1;
  let itemLineClamp = hasCode ? 2 : 3;

  if (hasCode) {
    if (itemLen > 32) {
      itemFontSize = '4.2pt';
      itemLineHeight = 1.05;
    } else if (itemLen > 20) {
      itemFontSize = '4.8pt';
      itemLineHeight = 1.08;
    } else {
      itemFontSize = '5.5pt';
    }
  } else {
    if (itemLen > 40) {
      itemFontSize = '4.4pt';
      itemLineHeight = 1.05;
      itemLineClamp = 3;
    } else if (itemLen > 24) {
      itemFontSize = '5.0pt';
      itemLineHeight = 1.08;
      itemLineClamp = 3;
    } else {
      itemFontSize = '5.5pt';
      itemLineClamp = 2;
    }
  }

  return (
    <div 
      className="bg-white border border-black box-border relative overflow-hidden shrink-0" 
      style={{ 
        width: '40mm', 
        height: '20mm', 
        fontFamily: '"Poppins", sans-serif',
        transform: scale !== 1 ? `scale(${scale})` : undefined,
        transformOrigin: 'top left',
      }}
    >
      {/* Content Container */}
      <div className="relative z-10 w-full h-full pt-[1mm] pb-[1mm] px-[1.5mm] flex flex-col">
        
        {/* Header Section */}
        <div className="flex items-center gap-[1.5mm] mb-[0.5mm] w-full shrink-0">
          {/* Logo */}
          <div className="flex items-center justify-center shrink-0 w-[4.5mm] h-[4.5mm]">
            <img src="/logo hitam sde.png" alt="Logo" className="w-full h-full object-contain object-left" />
          </div>
          {/* Company & Address */}
          <div className="flex flex-col justify-center flex-1 pb-[0.2mm]">
            <span style={{ color: goldenColor, fontSize: '4.76pt', fontWeight: 600, fontStyle: 'italic', lineHeight: 1.1 }}>
              PT. Satala Dermatech Essential
            </span>
            <span style={{ color: goldenColor, fontSize: '2.5pt', fontStyle: 'italic', fontWeight: 400, lineHeight: 1.1, marginTop: '0.2mm' }}>
              Jl.Aster Kav, Paspampres Kota Batu, Kab. Bogor, Jawa Barat
            </span>
          </div>
        </div>

        {/* Divider Line */}
        <div className="shrink-0" style={{ height: '0.4pt', backgroundColor: goldenColor, width: '100%', marginBottom: '0.8mm' }} />

        {/* Body Section */}
        <div className="flex-1 relative w-full flex flex-col overflow-hidden">
          
          <div className="flex-1 flex flex-col items-center justify-center w-full px-[1mm]">
            {/* Row 1: Nama Vendor */}
            <span style={{ color: goldenColor, fontSize: '4.5pt', fontWeight: 600, fontStyle: 'italic', lineHeight: 1.1, textAlign: 'center', width: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {cleanVendor}
            </span>

            {/* Row 2: Nama Item / Bibit (+ penomoran jika ada) */}
            <span 
              style={{ 
                color: goldenColor, 
                fontSize: itemFontSize, 
                fontWeight: 700, 
                fontStyle: 'italic', 
                lineHeight: itemLineHeight, 
                margin: '0.3mm 0', 
                textAlign: 'center', 
                wordBreak: 'break-word', 
                display: '-webkit-box', 
                WebkitLineClamp: itemLineClamp, 
                WebkitBoxOrient: 'vertical', 
                overflow: 'hidden', 
                width: '100%' 
              }}
            >
              {cleanItem}
            </span>
            
            {/* Row 3: Kode Item */}
            {cleanCode && (
              <span style={{ color: goldenColor, fontSize: '4.2pt', fontWeight: 600, fontStyle: 'italic', lineHeight: 1, textAlign: 'center', marginTop: '0.3mm', width: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {cleanCode}
              </span>
            )}
          </div>

          {/* Footer: Tanggal (kiri/tengah) dan Label Tag "Sample" (kanan) */}
          <div className="w-full flex items-end mt-auto pb-[0.2mm] px-[1mm] shrink-0">
            <div className="flex-1" />
            <span className="flex-none text-center" style={{ color: goldenColor, fontSize: '4.76pt', fontWeight: 600, fontStyle: 'italic', lineHeight: 1 }}>
              {cleanTanggal}
            </span>
            <div className="flex-1 flex justify-end">
              <span style={{ color: goldenColor, fontSize: '4.5pt', fontStyle: 'italic', fontWeight: 700, lineHeight: 1 }}>
                {labelTag}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
